import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";

import Logo from "../../Resources/Images/logo.png";
import GlobalContext from "../../Hooks/globalContext";
import LoginWrapper from "../../Components/Auth/LoginWrapper";
import Input from "../../Components/Common/Input";
import languagePack, { languageAction } from "../../Utils/language";
import Button from "../../Components/Common/DefaultButton";
import useInput from "../../Hooks/useInput";
import { HOST, NUMBER_REGEX } from "../../Utils/constants";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f6f6;
`;

const LoginForm = styled.div`
  width: 30vw;
  min-width: 333px;
  padding: 50px 30px 30px 30px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoImage = styled.img`
  width: 192px;
  height: auto;
  margin-bottom: 3vh;
`;

const _Button = styled(Button)``;

const _Input = styled(Input)`
  margin-bottom: 15px;
`;

const Container = ({ history }) => {
  const emailInput = useInput({ defaultValue: "" });
  const passwordInput = useInput({ defaultValue: "" });

  const { isLogin, isSession, getUser, modal, httpHeader, language } = useContext(GlobalContext);

  const onSubmit = async (e) => {
    e.preventDefault();

    const loginParams = {
      email: emailInput.value,
      password: passwordInput.value,
    };

    const { data } = await Axios.post(`${HOST}/login`, loginParams, httpHeader());

    if (data.status) {
      if (data.a === 0) {
        modal.setState(languagePack("잘못된 E-Mail 혹은 비밀번호입니다.", language.state));
      } else {
        isLogin.setState(true);
        sessionStorage.setItem("token", data.token);
        isSession.setState(true);
        await getUser(data.token);
        history.replace("/");
      }
    } else {
      switch (data.code) {
        case "invalid":
          modal.setState(languagePack("잘못된 E-Mail 혹은 비밀번호입니다.", language.state));
          break;
        case "server":
          modal.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
          break;
        default:
          modal.setState(languagePack("서버 오류입니다. 잠시 후에 다시 시도해주세요.", language.state));
          break;
      }
    }
  };

  return (
    <LoginWrapper onSubmit={onSubmit}>
      <Wrapper>
        <LoginForm>
          <LogoImage src={Logo} />
          <_Input {...emailInput} placeholder={languagePack("아이디", language.state)} />
          <_Input {...passwordInput} placeholder={languagePack("비밀번호", language.state)} type="password" />
          <_Button type="submit" block={true} text={languagePack("로그인", language.state)} />
        </LoginForm>
      </Wrapper>
    </LoginWrapper>
  );
};

export default Container;
